import { EkvDashboardState } from './ekv-dashboard.state'
import { HimiDashboardState } from './himi-dashboard.state'
import { PatientDashboardState } from './patient-dashboard.state'
import { PhmDashboardState } from './phm-dashboard.state'
import { SelbstzahlerDashboardState } from './selbstzahler-dashboard.state'

export const dashboardStates = [PhmDashboardState, EkvDashboardState, PatientDashboardState, HimiDashboardState, SelbstzahlerDashboardState]
